module.exports = __webpack_public_path__ + "img/kaernten-card_logo2024.e57a4e6d.svg";